import React from "react";

const GuardiumService = ({ t }) => {
  return (
    <div className="service-our-service-item-holder-content">
      <div className="container-fluid">
        <div className="row">
          <div className="service-our-service-custom-template-holder">
            <div className="serive-our-custom-template-text-block">
              <h1>{t("ibm.title3")}</h1>
              <p>{t("ibm.desc3")}</p>
            </div>
            <div
              className="serive-our-custom-template-image-block"
              style={{ backgroundImage: "url(/images/guardium-res.png)" }}
            >
              <ul>
                <li>{t("ibm.li-1")}</li>
                <li>{t("ibm.li-2")}</li>
                <li>{t("ibm.li-3")}</li>
                <li>{t("ibm.li-4")}</li>
                <li>{t("ibm.li-5")}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuardiumService;
